module.exports = __webpack_public_path__ + "static/media/free_from_app.9d006130.png";